import React from "react";

// Brand video also used on the Pakistan homepage.
// https://www.youtube.com/watch?v=g6eehy1PtUs
const BrandVideoSection = () => {
  const videoId = "g6eehy1PtUs";

  return (
    <section className="pt-20 pb-8 bg-white">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl md:text-[2.5rem] font-bold text-[#222] mb-4">
            Why Families Trust Select Proposal
          </h2>
          <p className="text-lg text-[#555] max-w-[600px] mx-auto">
            A quick look at how we help families find the right rishta
          </p>
        </div>

        <div className="flex justify-center">
          <div className="relative w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-2xl">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}?rel=0`}
              title="Select Proposal — Pakistan's #1 Trusted Matrimonial Service"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandVideoSection;
